import { createFileRoute } from '@tanstack/react-router';

import { LoadingPage } from '@nesso/ui/blocks/loading-page';

import {
    BillingDocumentsPage,
    billingDocumentsBeforeLoad,
} from '@/pages/settings/billing-documents';

export const Route = createFileRoute('/settings/billing-documents')({
    beforeLoad: billingDocumentsBeforeLoad,
    component: BillingDocumentsPage,
    pendingComponent: LoadingPage,
});
